import { PageTitle } from '_metronic/layout/core'

import Select from 'react-select'
import TabsButtonGroup from 'Presentation/Components/Tabs/ButtonGroup'
import NotificationOption from './Components/NotificationOption'

import useViewModel from './ViewModel'
import { TABS } from '../Config'

const ProfileNotificationView: React.FC = () => {
	const { companyName, data, currentTab, onChangeTab } = useViewModel()

	return (
		<ViewPageTitle companyName={companyName}>
			<div className="row gy-5">
				<div className="col-12 d-none d-xl-block">
					<TabsButtonGroup
						manualActiveTab={currentTab}
						changeTab={onChangeTab}
						tabNames={TABS.map(tab => tab.tabName)}
						tabContents={[<></>]}
					/>
				</div>

				<div className="col-12 d-xl-none">
					<Select
						isSearchable={false}
						options={TABS.map((tab, idx) => ({ value: idx, label: tab.tabName }))}
						value={{ label: TABS.find((_, idx) => idx === currentTab)?.tabName }}
						styles={{
							control: (baseStyles, state) => ({
								...baseStyles,
								border: '1px solid #e1e3ea',
								height: 40,
							}),
							menu: (baseStyles, state) => ({
								...baseStyles,
								zIndex: 9999,
							}),
						}}
						onChange={(selected: any) => {
							if (selected !== null) onChangeTab(Number(selected?.value))
						}}
					/>
				</div>

				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-body">
							{data.map(n => (
								<div
									className={`mt-5 mb-10 pb-5 d-flex flex-column flex-xl-row border-bottom`}
									key={`notification-${n.title}`}>
									<label
										className={`form-label col-12 col-xl-5 mb-0 mb-5 mb-xl-0`}
										data-testid="form-input-label-component">
										<div className="d-flex flex-column">
											<span>{n.title}</span>
											<span className="text-kumopack-grey-600 fs-8 w-75">{n.description}</span>
										</div>
									</label>
									<div className="col-12 col-xl-7">
										{n.items.map(i => (
											<NotificationOption
												key={`notification-option-${n.title}-${i.title}`}
												{...i}
											/>
										))}
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode; companyName: string }> = ({
	children,
	companyName,
}) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'My Account',
						path: '/profile',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Plan',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				{companyName}
			</PageTitle>

			{children}
		</>
	)
}

export default ProfileNotificationView
